import { API_TAGS } from '@/shared/api/api-tags';
import { baseApi } from '@/shared/api/base-api';

import type { Notification } from '../types/notification.types';

export const notificationsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getNotifications: builder.query<Notification[], undefined>({
      query: () => '/notifications',
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ id }) => ({
                type: API_TAGS.Notifications,
                id,
              })),
              { type: API_TAGS.Notifications, id: 'LIST' },
            ]
          : [{ type: API_TAGS.Notifications, id: 'LIST' }],
    }),

    markAsRead: builder.mutation<Notification, string>({
      query: (id) => ({
        url: `/notifications/${id}/read`,
        method: 'PATCH',
      }),
      invalidatesTags: (_result, _error, id) => [
        { type: API_TAGS.Notifications, id },
        { type: API_TAGS.Notifications, id: 'LIST' },
      ],
      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          notificationsApi.util.updateQueryData(
            'getNotifications',
            undefined,
            (draft) => {
              const notification = draft.find((n) => n.id === id);
              if (notification) notification.read = true;
            },
          ),
        );
        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
      },
    }),

    markAllAsRead: builder.mutation<{ success: boolean }, undefined>({
      query: () => ({
        url: '/notifications/read-all',
        method: 'PATCH',
      }),
      invalidatesTags: [{ type: API_TAGS.Notifications, id: 'LIST' }],
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          notificationsApi.util.updateQueryData(
            'getNotifications',
            undefined,
            (draft) => {
              draft.forEach((n) => {
                n.read = true;
              });
            },
          ),
        );
        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
      },
    }),
  }),
});

export const {
  useGetNotificationsQuery,
  useMarkAsReadMutation,
  useMarkAllAsReadMutation,
} = notificationsApi;
